import { LayoutShell, useDebounce } from '@bbl-digital/snorre-v2'
import { FCWithChildren } from 'global'
import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router'
import { getLogoInverted } from 'shared/utils/theme'
import FooterLayout from '../shared/FooterLayout'
import Toaster from '../shared/Toaster'
import useMenuLayout from '../shared/hooks/useMenuLayout'
import MenuLayout from './MenuLayout'
import MobileTabs from './MobileTabs'
import TopLayout from './TopLayout'
import { ServiceMessage } from './TopLayout/shared/ServiceMessage'
import { Content } from './styles'

const LayoutContent: FCWithChildren = ({ children }) => {
  const [submenuOpen, _setSubmenuOpen] = useState(false)
  const contentRef = useRef<HTMLDivElement>(null)
  const navRef = useRef<HTMLDivElement>(null)

  const { location } = useHistory()

  const { getSideMenyWidth, handleOpen, isMobile, isOpen } = useMenuLayout()

  const onSkipNav =
    location.pathname !== '/' ? () => navRef?.current?.focus() : undefined

  const [insideSideBar, setInsideSideBar] = useState(undefined)

  const insideSideBarDebounced = useDebounce(insideSideBar, isOpen ? 700 : 200)

  useEffect(() => {
    const keepExpanded = localStorage.getItem('sidebarKeepExpanded') === 'true'

    if (keepExpanded) {
      handleOpen(true)
      return
    }
    if (isMobile || insideSideBar === undefined) return
    if (insideSideBarDebounced && isOpen) return

    handleOpen(!isOpen)
  }, [insideSideBarDebounced])

  return (
    <LayoutShell
      sideBar={
        !isMobile && (
          <div
            onMouseEnter={() => setInsideSideBar(true)}
            onFocus={() => setInsideSideBar(true)}
            onBlur={(e) => {
              if (e.relatedTarget === null) {
                return
              }
              setInsideSideBar(false)
            }}
            onMouseLeave={() => {
              setInsideSideBar(false)
            }}
          >
            <MenuLayout open={isOpen} logo={getLogoInverted()} />
          </div>
        )
      }
      onSkipToNav={onSkipNav} // Not on home page
      sideBarWidth={getSideMenyWidth()}
      onSkipToMainContent={() => contentRef?.current?.focus()}
      topBar={<TopLayout />}
      footer={<FooterLayout />}
      isOpen={isOpen}
    >
      <Toaster />
      <ServiceMessage />

      <Content
        ref={contentRef}
        tabIndex={-1}
        setIndex={submenuOpen}
        className="bg-surface-common-background"
      >
        {children}
      </Content>

      {/* Is null / doesnt render if not mobile */}
      <MobileTabs />
    </LayoutShell>
  )
}

export default LayoutContent
